import { memo, useEffect, useState } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import ProductTagService from "@/services/product_tag"
import ProductCategoryService from "@/services/product_category"
import { Box, Button, Spacer, Stack, Text } from "@chakra-ui/react"
import HomeBanner from "./HomeBanner";
import { Tabs } from "@chakra-ui/react"
import { LuCheck, LuFolder, LuSquareCheck, LuUser } from "react-icons/lu"
import { useStoreProduct } from "contexts/store_product";
import _ from "lodash"





const Home = () => {


    const { products } = useStoreProduct();
    const [productsFilled, setProductFilled] = useState([]);
    const [tags, setTags] = useState([])
    const [categories, setCategories] = useState([])
    const [filter, setFilter] = useState({ tab: "tags" })
    useEffect(() => {

        loadTags();
        loadCategory();
    }, [])

    useEffect(() => {
        filterProduct();
    }, [products, filter])



    const filterProduct = () => {
        console.log("filter ", filter)
        if (filter.tab == "tags") {
            if (filter.tag) {
                var lst = products.filter(x => {
                    if (!_.isArray(x.tags)) {
                        return false;
                    }
                    return x.tags.includes(filter.tag)
                })
                setProductFilled(lst);
            } else {
                setProductFilled([...products])
            }
            return;
        }


        if (filter.tab == "category") {
            if (filter.category) {
                var lst = products.filter(x => {

                    return x.category == filter.category;
                })
                setProductFilled(lst);
            } else {
                setProductFilled([...products])
            }
            return;
        }

        setProductFilled([...products]);
    }

    const loadTags = async () => {
        const tagService = new ProductTagService();
        var data = await tagService.list();
        setTags(data);
    }

    const loadCategory = async () => {
        const cateService = new ProductCategoryService();
        var data = await cateService.list();

        setCategories(data);
    }
    const toogleTag = (id) => {
        if (filter.tag != id) {
            setFilter({ ...filter, tag: id, })
        } else {
            setFilter({ ...filter, tag: null })
        }
    }

    const toogleCategory = (id) => {
        if (filter.category != id) {
            setFilter({ ...filter, category: id, })
        } else {
            setFilter({ ...filter, category: null })
        }
    }

    return (
        <div>
            <Stack>
                <HomeBanner data={products}></HomeBanner>
                <Tabs.Root defaultValue="tags" onValueChange={(e) => { console.log(e); setFilter({ ...filter, tab: e.value }) }}  >
                    <Tabs.List>
                        <Tabs.Trigger value="tags">

                            Sản phẩm
                        </Tabs.Trigger>
                        <Tabs.Trigger value="category">
                            Danh mục
                        </Tabs.Trigger>

                    </Tabs.List>
                    <Tabs.Content value="tags">
                        <div>
                            <Stack>

                                <Box>
                                    <Stack direction={"row"} style={{ width: "100%", overflow: "scroll" }}>

                                        {tags.map((x => {
                                            return (<Button variant={"outline"} size={"sm"} onClick={e => toogleTag(x.id)}>
                                                {filter.tag == x.id &&
                                                    <LuCheck></LuCheck>
                                                }


                                                {x.name}</Button>)
                                        }))}


                                    </Stack>
                                </Box>
                            </Stack>
                        </div>
                    </Tabs.Content>
                    <Tabs.Content value="category">
                        <div>
                            <Stack>


                                <Stack direction={"row"} style={{ width: "100%", overflow: "scroll" }}>
                                    {categories.map((x => {
                                        return (<Button variant={"outline"} size={"sm"} onClick={e => toogleCategory(x.id)}>
                                            {filter.category == x.id &&
                                                <LuCheck></LuCheck>
                                            }

                                            {x.name}</Button>)
                                    }))}


                                </Stack>

                            </Stack>
                        </div>
                    </Tabs.Content>

                </Tabs.Root>
                <ProductList data={productsFilled}></ProductList>
            </Stack>

        </div>
    )
}

export default memo(Home)